const state = {
  offerFields: [],
  messageLists: []
};

const actions = {
  setOfferFields: ({ commit }, offerFields) => {
    commit('addOfferFields', offerFields);
  },
  setMessageLists: ({ commit }, messageLists) => {
    commit('addMessageLists', messageLists);
  }
};

const mutations = {
  addOfferFields(state, offerFields) {
    state.offerFields = offerFields;
  },
  addMessageLists(state, messageLists) {
    state.messageLists = messageLists;
  }
};

export default {
  namespaced: true,
  actions,
  mutations,
  state
};
